import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { UploadDetailsFormState } from "../types/form.types";

const initialState: UploadDetailsFormState = {
	email: "",
	phone: "",
	fullName: "",
	company: "",
	jobReference: "",
	dueDate: "",
	printType: "",
	description: "",
	purpose: "",
	purposeName: "",
	otpVerifiedEmail: "",
	otpVerifiedAt: "",
	papertype: "",
	sizeprint: "",
	binding: "",
	noofSets: "",
	arcaccountno: "",
	willcall: true,
	address1: "",
	city: "",
	CountryName: "",
	ZipCode: "",
	StateName: "",
	stateid: "",
	countryid: "",
};

const uploadFormSlice = createSlice({
	name: "uploadForm",
	initialState,
	reducers: {
		// Form field update action
		updateFormField: <Field extends keyof UploadDetailsFormState>(
			state: UploadDetailsFormState,
			action: PayloadAction<{
				field: Field;
				value: UploadDetailsFormState[Field];
			}>
		) => {
			state[action.payload.field] = action.payload.value;
		},

		setOtpVerified: (
			state,
			action: PayloadAction<{ email: string; timestamp: string }>
		) => {
			state.otpVerifiedEmail = action.payload.email;
			state.otpVerifiedAt = action.payload.timestamp;
		},

		resetDueDate: (state) => {
			state.dueDate = "";
		},

		resetform: () => {
			return initialState;
		},
	},
});

export const { updateFormField, setOtpVerified, resetDueDate, resetform } =
	uploadFormSlice.actions;

export default uploadFormSlice.reducer;
